import isUrl from 'is-url';
import XRegExp from 'xregexp';
import { isDate, isFuture } from 'date-fns';
import i18next from 'i18next';

export const username = '(^|\\s)(?<username>[@+][\\p{L}\\d-]*)';
const popularGit =
  '^https?://(www.)?git(hub|lab).com/(?<organization>[\\w-]+)/(?<project>[\\w-]+)';

const googleDrive =
  '^https?://drive.google.com/drive/(u/[0-9]+/)?folders/(?<folder_id>[-\\w]{25,})';

const droboxSharedFolder =
  '^(https://)?(www\\.)?dropbox\\.com/sh/[\\w]+/[\\w]+';

const dropboxUserFolder = '^(https://)?(www.)?dropbox.com/home/(([-\\w]+)/?)+$';

export const emailValidator = val => {
  const email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return email.test(val);
};

export const usernameValidator = val => {
  const usernameRule = XRegExp(username);
  return usernameRule.test(val);
};

const isUsername = fieldStore => {
  const value = fieldStore.value || '';
  if (usernameValidator(value.trim())) {
    return [true, ''];
  }
  return [false, i18next.t("Hmm... That doesn't look like a username")];
};

const isEmail = fieldStore => {
  const value = fieldStore.value || '';
  if (emailValidator(value.trim())) {
    return [true, ''];
  }
  return [false, i18next.t("Hmm... That doesn't look like an email address")];
};

const isURL = fieldStore => {
  const value = fieldStore.value || '';
  const trimmedValue = value.trim();
  const formattedInput = /http(s)?:\/\//.test(trimmedValue)
    ? trimmedValue
    : `http://${trimmedValue}`;
  if (isUrl(formattedInput)) {
    return [true, ''];
  }
  return [false, i18next.t('Hmm... That url looks wrong! Please take a look.')];
};

const isInvitation = fieldStore => {
  const usernameCheck = isUsername(fieldStore);
  const emailCheck = isEmail(fieldStore);
  if (usernameCheck[0] || emailCheck[0]) {
    return [true, ''];
  }
  return [
    false,
    i18next.t("Hmm... That doesn't look like an email address or username"),
  ];
};

export const importServices = ['Github/Gitlab'];
// if (IMPORTER_GOOGLE_API_CLIENT_ID) {
//   importServices.push('Google Drive');
// }
if (IMPORTER_DROPBOX_APP_KEY) {
  importServices.push('Dropbox');
}

const importURLValidator = fieldStore => {
  // FIXME
  const url = fieldStore.value;
  const popularGitRule = XRegExp(popularGit);
  const googleDriveRule = XRegExp(googleDrive);
  const dropboxSharerdFolderRule = XRegExp(droboxSharedFolder);
  const dropboxUserFolderRule = XRegExp(dropboxUserFolder);

  if (popularGitRule.test(url)) {
    return [true, 'git'];
  }
  if (IMPORTER_GOOGLE_API_CLIENT_ID && googleDriveRule.test(url)) {
    return [true, 'google_drive'];
  }

  if (
    IMPORTER_DROPBOX_APP_KEY &&
    (dropboxUserFolderRule.test(url) || dropboxSharerdFolderRule.test(url))
  ) {
    return [true, 'dropbox'];
  }

  return [
    false,
    i18next.t(`The URL doesn't match any of: {{importServices}}: `, {
      importServices: importServices.join(', '),
    }),
  ];
};

export const isFutureDate = fieldStore => {
  const date = fieldStore.value;
  if (!isDate(date)) {
    return [false, i18next.t('Invalid date')];
  }
  if (!isFuture(date)) {
    return [false, i18next.t('Date is not in the future!')];
  }
  return [true, ''];
};

export const Validators = {
  url: isURL,
  email: isEmail,
  username: isUsername,
  invitation: isInvitation,
  importurl: importURLValidator,
  futureDate: isFutureDate,
};
